module.exports = __webpack_public_path__ + "img/learn-more-illu-delivery-truck.cbd9a3e1.svg";